__turbopack_context__.v({
  "input": "TextInput-module__w1vrVG__input",
  "root": "TextInput-module__w1vrVG__root",
});
